import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { AdItem, AdImageContainer } from './style';
import { useTranslation } from 'react-i18next';

const Component = props => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { 
        rootMargin: '100px',
        threshold: 0.01
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <AdItem className="aditem">
      <Link to={`/ad/${props.data.public_id}`}>
        <AdImageContainer ref={imgRef}>
          {!imageLoaded && !imageError && (
            <div className="placeholder" />
          )}
          
          {isVisible && !imageError && (
            <img
              src={props.data.image}
              alt={props.data.title}
              loading="lazy"
              decoding="async"
              width="400"
              height="300"
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageError(true)}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: imageLoaded ? 1 : 0,
                transition: 'opacity 0.3s ease-in-out'
              }}
            />
          )}

          {imageError && (
            <div className="error-placeholder">
              <i className="fas fa-image" />
            </div>
          )}
          {props.data.listing_type === 'rent' && (
            <div className="rent-badge">
              RENT
            </div>
          )}
          {props.data.price_negotiable ? (
            <div className="price-badge negotiable">
              {t('negotiable_price')}
            </div>
          ) : props.data.price ? (
            <div className="price-badge fixed">
              Rp {Math.round(parseFloat(props.data.price)).toLocaleString('id-ID')}
            </div>
          ) : null}
        </AdImageContainer>
        <div className="itemName">
          {props.data.title}
        </div>
      </Link>
    </AdItem>
  );
};

export default Component;